// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1HwNr","file":"styles_file__3mKCl"};